import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-gray-700" }, "Fluxo desabilitado", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  "data-testid": "evidence-flow-disabled-modal",
  class: "text-sm text-gray-600"
}, " O envio de evidências por este fluxo está temporariamente desabilitado. Procure sua liderança para entender qual fluxo está sendo utilizado para o envio da evidência. ", -1)
const _hoisted_3 = { class: "flex justify-end" }

import Modal from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EvidenceFlowDisabledModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {





const close = () => emit('update:modelValue', false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": true,
    "has-footer-border": true,
    "max-width": "max-w-md",
    onClose: close
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FilledButton, {
          text: "Entendi",
          width: "120px",
          "data-testid": "evidence-flow-disabled-ok",
          onClick: close
        })
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})